document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("find-in-store-modal");
  const variantDataScript = document.getElementById("product-variants-json");
  const optionNamesScript = document.getElementById("product-option-names-json");
  const brandDataScript = document.getElementById("product-brand-json");

  // Flag that is set to true once `state` has been initialised.
  // Guards any early calls (e.g. variant:changed before the modal is opened).
  let isStateReady = false;

  // --- Sync modal state with main product variant changes ---
  function syncModalVariantWithMainProduct() {
    if (!isStateReady || !variantDataScript) return;
    const allVariants = JSON.parse(variantDataScript.textContent);
    const variantInput = document.querySelector('input[name="id"], .product-variant-id');
    if (!variantInput) return;
    const variantId = variantInput.value;
    const foundVariant = allVariants.find(v => String(v.id) === String(variantId));
    if (foundVariant) {
      state.selectedOptions = [...foundVariant.options];
      state.currentSku = foundVariant.sku;
    }
  }


  // --- Delegated click listener: survives any DOM replacement of the button ---
  // This replaces the fragile btn.onclick / attachBtnHandler pattern.
  // The theme (product-info.js) uses HTMLUpdateUtility.viewTransition to swap
  // product-info DOM nodes on every variant change, which destroys any .onclick
  // assigned directly to the button element.
  document.addEventListener("click", function (e) {
    if (!e.target.closest("#find-in-store-btn")) return;
    if (!isStateReady) return;
    state.modalOpenTime = Date.now();
    trackAnalyticsEvent("modal_opened");
    modal.style.display = "flex";
    disableBodyScroll();
    initVariantSelector();
    findAllStores();
    setTimeout(initAutocomplete, 100);
    if (!isGoogleMapsApiLoaded) {
      loadGoogleMapsApi(initAutocomplete);
    }
  });

  // Listen for the theme's pub/sub 'variant-change' event.
  // product-info.js publishes PUB_SUB_EVENTS.variantChange ('variant-change')
  // AFTER updating the hidden input[name="id"] via updateVariantInputs(), so
  // this is the correct hook to read the new variant and sync state.
  if (typeof subscribe === 'function') {
    subscribe('variant-change', function ({ data }) {
      if (!isStateReady) return;
      const variant = data?.variant;
      if (variant) {
        state.selectedOptions = [...variant.options];
        state.currentSku = variant.sku;
      } else {
        syncModalVariantWithMainProduct();
      }
    });
  }

  // Fallback: also listen for the DOM 'change' event on the hidden variant input
  // (dispatched by updateVariantInputs in product-info.js and by other themes).
  document.addEventListener("change", function (e) {
    const t = e.target;
    if (t && (t.name === "id" || t.classList.contains("product-variant-id"))) {
      syncModalVariantWithMainProduct();
    }
  });


  if (!modal || !variantDataScript) {
    return;
  }

  if (modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }

  // No longer need attachBtnHandler — the delegated listener above handles all clicks.
  // shopify:section:load no longer needs to re-bind the button either.

  const shopDomain = (modal.dataset.shopDomain || "").trim().toLowerCase();

  function disableBodyScroll() {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    document.body.classList.add("modal-open-no-scroll");
  }

  function enableBodyScroll() {
    document.body.classList.remove("modal-open-no-scroll");
    document.body.style.paddingRight = "";
  }

  let isGoogleMapsApiLoaded = false;

  const mapsApiUrl = modal.dataset.mapsApiUrl || "";
  let apiBaseUrl = modal.dataset.apiUrl;

  if (!apiBaseUrl && mapsApiUrl) {
    try {
      const url = new URL(mapsApiUrl);
      apiBaseUrl = `${url.protocol}//${url.host}`;
    } catch (error) {
      const match = mapsApiUrl.match(/https?:\/\/[^\/]+/);
      if (match) apiBaseUrl = match[0];
    }
  }

  if (!apiBaseUrl) {
    apiBaseUrl = window.location.origin;
  }

  let brand = "Tekkie Town";
  if (brandDataScript) {
    try {
      brand = JSON.parse(brandDataScript.textContent.trim());
    } catch (error) {
      brand = "Tekkie Town";
    }
  }

  const state = {
    shopDomain: shopDomain,
    brand: brand,
    allVariants: JSON.parse(variantDataScript.textContent),
    productOptions: optionNamesScript
      ? JSON.parse(optionNamesScript.textContent)
      : [],
    selectedOptions: [],
    currentSku: null,
    lastSearchType: "all",
    lastLocation: null,
    autocomplete: null,
    modalOpenTime: null,
    apiBaseUrl: apiBaseUrl,
    uiColors: null,
  };

  // State is now ready — allow variant-sync calls to proceed
  isStateReady = true;

  // Initial sync in case a variant was pre-selected before the modal initialised
  syncModalVariantWithMainProduct();

  function getUiColors() {
    if (state.uiColors) {
      return state.uiColors;
    }

    const triggerEl = document.getElementById("find-in-store-btn");
    const triggerStyles = triggerEl ? window.getComputedStyle(triggerEl) : null;
    const modalContent = modal.querySelector(".find-in-store-modal-content");
    const modalStyles = modalContent
      ? window.getComputedStyle(modalContent)
      : window.getComputedStyle(document.body);

    state.uiColors = {
      navy: triggerStyles?.color || "rgb(18, 41, 102)",
      surface: modalStyles.backgroundColor || "rgb(255, 255, 255)",
      mutedNavy: "rgba(18, 41, 102, 0.08)",
      mutedNavyHover: "rgba(18, 41, 102, 0.06)",
      disabledText: "rgba(28, 33, 52, 0.35)",
    };

    return state.uiColors;
  }

  function getOrCreateSessionId() {
    let sessionId = sessionStorage.getItem("fis_session_id");
    if (!sessionId) {
      sessionId =
        "session_" +
        Date.now() +
        "_" +
        Math.random().toString(36).substr(2, 9);
      sessionStorage.setItem("fis_session_id", sessionId);
    }
    return sessionId;
  }

  function trackAnalyticsEvent(eventType, additionalData = {}) {
    const data = {
      eventType,
      shopDomain: state.shopDomain,
      brand: state.brand,
      sessionId: getOrCreateSessionId(),
      sku: state.currentSku,
      variant:
        state.selectedOptions.length > 0 ? state.selectedOptions : null,
      userAgent: navigator.userAgent,
      referrer: document.referrer,
      ...additionalData,
    };

    fetch(`${state.apiBaseUrl}/api/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
      keepalive: true,
    }).catch(() => {});
  }

  trackAnalyticsEvent("product_page_view");

  const elements = {
    closeBtn: modal.querySelector(".find-in-store-close"),
    resultsContainer: document.getElementById("find-in-store-results"),
    variantSelectorContainer: document.getElementById(
      "fis-variant-selector-container"
    ),
  };

  const infoIconSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>';
  const preloaderSvg =
    '<svg class="preloader-spinner" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>';

  function applyVariantPillBaseStyles(input, label) {
    const colors = getUiColors();

    Object.assign(input.style, {
      position: "absolute",
      width: "1px",
      height: "1px",
      padding: "0",
      margin: "-1px",
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      border: "0",
    });

    Object.assign(label.style, {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      minWidth: "7rem",
      margin: "0",
      padding: "1rem 1.6rem",
      border: `0.1rem solid ${colors.navy}`,
      borderRadius: "var(--inputs-radius)",
      backgroundColor: colors.surface,
      color: colors.navy,
      fontSize: "1.35rem",
      fontWeight: "600",
      letterSpacing: "0.04rem",
      lineHeight: "1",
      boxShadow: `inset 0 0 0 0.1rem ${colors.mutedNavy}`,
      cursor: "pointer",
      transition:
        "transform 0.15s ease, border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease, opacity 0.15s ease",
    });
  }

  function syncVariantPillStates() {
    const colors = getUiColors();
    const fieldsets = elements.variantSelectorContainer.querySelectorAll("fieldset");

    fieldsets.forEach((fieldset) => {
      const inputs = fieldset.querySelectorAll('input[type="radio"]');

      inputs.forEach((input) => {
        const label = input.nextElementSibling;
        if (!label) {
          return;
        }

        applyVariantPillBaseStyles(input, label);

        if (input.disabled) {
          label.style.opacity = "0.45";
          label.style.backgroundColor = "transparent";
          label.style.color = colors.disabledText;
          label.style.textDecoration = "line-through";
          label.style.cursor = "not-allowed";
          label.style.boxShadow = "none";
          return;
        }

        label.style.opacity = "1";
        label.style.textDecoration = "none";
        label.style.cursor = "pointer";

        if (input.checked) {
          label.style.backgroundColor = colors.navy;
          label.style.borderColor = colors.navy;
          label.style.color = colors.surface;
          label.style.boxShadow = "none";
        } else {
          label.style.backgroundColor = colors.surface;
          label.style.borderColor = colors.navy;
          label.style.color = colors.navy;
          label.style.boxShadow = `inset 0 0 0 0.1rem ${colors.mutedNavy}`;
        }
      });
    });
  }

  function initVariantSelector() {
    if (!state.productOptions.length) {
      state.productOptions = state.allVariants[0].options.map((option, index) => {
        if (typeof option === "string") {
          return `Option ${index + 1}`;
        }
        return option.name;
      });
    }
    elements.variantSelectorContainer.innerHTML = "";
    const initialVariant =
      getVariantFromPage() || state.allVariants.find((variant) => variant.available);

    if (initialVariant) {
      state.selectedOptions = [...initialVariant.options];
    }

    state.productOptions.forEach((optionName, index) => {
      const optionValues = [
        ...new Set(state.allVariants.map((variant) => variant.options[index])),
      ];

      const optionLabel = String(optionName || "").trim();
      const normalizedOptionLabel = optionLabel.toLowerCase();

      if (
        optionValues.length === 1 &&
        (normalizedOptionLabel.includes("colour") ||
          normalizedOptionLabel.includes("color"))
      ) {
        return;
      }

      if (optionValues.length > 0) {
        const fieldset = document.createElement("fieldset");
        fieldset.className = "fis-variant-pills";
        fieldset.dataset.index = index;

        let variantTitle = optionLabel || `Option ${index + 1}`;
        if (normalizedOptionLabel.includes("colour")) {
          variantTitle = "Select Colour";
        } else if (normalizedOptionLabel.includes("color")) {
          variantTitle = "Select Color";
        } else if (normalizedOptionLabel.includes("size")) {
          variantTitle = "Select Size";
        }

        const legend = document.createElement("legend");
        legend.className = "fis-variant-label";
        legend.textContent = variantTitle;
        fieldset.appendChild(legend);

        const pillList = document.createElement("div");
        pillList.className = "fis-variant-pill-list";
        Object.assign(pillList.style, {
          display: "flex",
          flexWrap: "wrap",
          gap: "0.8rem",
        });

        optionValues.forEach((value) => {
          const inputId = `fis-option-${index}-${value.replace(/\s+/g, "-")}`;
          const input = document.createElement("input");
          input.type = "radio";
          input.id = inputId;
          input.name = `fis-option-${index}`;
          input.value = value;

          if (state.selectedOptions[index] === value) {
            input.checked = true;
          }

          const label = document.createElement("label");
          label.className = "fis-variant-pill";
          label.htmlFor = inputId;
          label.textContent = value;

          pillList.appendChild(input);
          pillList.appendChild(label);
        });

        fieldset.appendChild(pillList);

        elements.variantSelectorContainer.appendChild(fieldset);
      }
    });

    syncVariantPillStates();
    updateVariantAvailability();
    updateCurrentSkuFromState();
    if (elements.variantSelectorContainer.dataset.bound !== "true") {
      elements.variantSelectorContainer.addEventListener("change", onVariantChange);
      elements.variantSelectorContainer.dataset.bound = "true";
    }
  }

  function getVariantFromPage() {
    const variantInput = document.querySelector(
      'input[name="id"], .product-variant-id'
    );
    if (!variantInput) return null;
    return state.allVariants.find((variant) => variant.id == variantInput.value);
  }

  function updateCurrentSkuFromState() {
    const foundVariant = state.allVariants.find((variant) =>
      variant.options.every(
        (optionValue, index) => optionValue === state.selectedOptions[index]
      )
    );
    state.currentSku = foundVariant ? foundVariant.sku : null;
    return !!foundVariant;
  }

  function updateVariantAvailability() {
    const fieldsets = elements.variantSelectorContainer.querySelectorAll("fieldset");
    fieldsets.forEach((fieldset) => {
      const index = parseInt(fieldset.dataset.index, 10);
      const inputs = fieldset.querySelectorAll('input[type="radio"]');

      inputs.forEach((input) => {
        const tempOptions = [...state.selectedOptions];
        tempOptions[index] = input.value;

        const isAvailable = state.allVariants.some((variant) =>
          variant.options.every(
            (optionValue, optionIndex) =>
              tempOptions[optionIndex] === null ||
              optionValue === tempOptions[optionIndex]
          )
        );
        input.disabled = !isAvailable;
      });
    });

    syncVariantPillStates();
  }

  function onVariantChange(event) {
    const fieldset = event.target.closest("fieldset");
    if (!fieldset) return;

    const index = parseInt(fieldset.dataset.index, 10);
    state.selectedOptions[index] = event.target.value;

    updateVariantAvailability();
    if (updateCurrentSkuFromState()) {
      if (state.lastSearchType === "location" && state.lastLocation) {
        findStoresByLocation(state.lastLocation);
      } else {
        findAllStores();
      }
    } else {
      showResults(
        `<div class="notice-box info">${infoIconSvg}<span>This combination is not available.</span></div>`
      );
    }
  }

  function runSearch() {
    const sku = state.currentSku;
    if (!sku) {
      showResults(
        `<div class="notice-box info">${infoIconSvg}<span>This product variant does not have a SKU.</span></div>`
      );
      return;
    }

    const isLocationSearch =
      state.lastSearchType === "location" && state.lastLocation;
    const body = {
      sku,
      shop: state.shopDomain,
      brand: state.brand,
      variant: state.selectedOptions.length > 0 ? state.selectedOptions : null,
    };

    if (isLocationSearch) {
      body.location = state.lastLocation;
    }

    fetch(`${state.apiBaseUrl}/api/find-in-store`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => (response.ok ? response.json() : Promise.reject(response)))
      .then((data) => {
        if (data.stores && data.stores.length > 0) {
          if (isLocationSearch) {
            data.stores.sort((left, right) => left.distance - right.distance);
          } else {
            data.stores.sort((left, right) =>
              left.store.name.localeCompare(right.store.name)
            );
          }

          renderStoreList(data.stores, isLocationSearch);
          trackAnalyticsEvent(
            isLocationSearch ? "search_by_location" : "search_all_stores",
            {
              resultsCount: data.stores.length,
              location: isLocationSearch ? state.lastLocation : null,
            }
          );
        } else {
          const isTekkieTown =
            state.brand &&
            typeof state.brand === "string" &&
            state.brand.trim().toLowerCase() === "tekkie town";
          let message;
          if (isTekkieTown) {
            message = isLocationSearch
              ? "No stores near this location has stock for your selected size or variant. Try another size or variant, or search a different area."
              : "No stores were found with stock for this size or variant. Try another size or variant.";
          } else {
            message = isLocationSearch
              ? "This product is not currently available in stores near the selected location."
              : "This product is not currently available in any Tekkie Town store.";
          }
          showResults(
            `<div class="notice-box info">${infoIconSvg}<span>${message}</span></div>`
          );
          trackAnalyticsEvent(
            isLocationSearch ? "search_by_location" : "search_all_stores",
            {
              resultsCount: 0,
              location: isLocationSearch ? state.lastLocation : null,
              ...(data.nonRetailStockOnly ? { nonRetailStockOnly: true } : {}),
            }
          );
        }
      })
      .catch(handleError);
  }

  function findAllStores() {
    state.lastSearchType = "all";
    state.lastLocation = null;
    showResults(
      `<div class="notice-box info">${preloaderSvg}<span>Checking all Tekkie Town stores...</span></div>`
    );
    runSearch();
  }

  function findStoresByLocation(location) {
    state.lastSearchType = "location";
    state.lastLocation = location;
    showResults(
      `<div class="notice-box info">${preloaderSvg}<span>Finding stock near you...</span></div>`
    );
    runSearch();
  }

  function renderStoreList(stores, showDistance) {
    // Only display stores with quantity > 1 for Tekkie Town
    let filteredStores = stores;
    const isTekkieTown =
      state.brand &&
      typeof state.brand === "string" &&
      state.brand.trim().toLowerCase() === "tekkie town";
    if (isTekkieTown) {
      filteredStores = stores.filter((storeData) => storeData.quantity > 1);
    }
    if (filteredStores.length === 0) {
      const message = isTekkieTown
        ? showDistance
          ? "No stores near this location have stock for your selected size or variant. Try another size or variant, or search a different area."
          : "No stores were found with stock for this size or variant. Try another size or variant."
        : showDistance
          ? "This product is not currently available in stores near the selected location."
          : "This product is not currently available in any Tekkie Town store.";
      showResults(
        `<div class="notice-box info">${infoIconSvg}<span>${message}</span></div>`
      );
      return;
    }
    let listHtml = '<ul class="store-list">';
    filteredStores.forEach((storeData, index) => {
      const { store, distance, quantity } = storeData;
      const storeId = store.name.replace(/[^a-zA-Z0-9]/g, "") + index;
      const distanceHtml = showDistance
        ? `<small>${distance.toFixed(1)} km away</small>`
        : "";
      const isLowStock = quantity <= 3;
      const availabilityMessage = isLowStock
        ? "Available in store with low stock"
        : "Available in store";
      const availabilityClass = isLowStock ? "low-stock" : "";

      listHtml += `
        <li class="store-list-item" id="store-item-${storeId}" data-store-name="${store.name.replace(
          /"/g,
          "&quot;"
        )}">
          <div class="store-summary">
            <div>
              <h4>${store.name} ${distanceHtml}</h4>
              <p>${store.address || "Address not available"}</p>
              <p class="store-availability ${availabilityClass}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>
                <span>${availabilityMessage}</span>
              </p>
            </div>
            <button class="store-details-toggle button button--tertiary" data-target="${storeId}">See More</button>
          </div>
          <div class="store-details-collapsible">
            <div class="store-details-map" id="map-for-${storeId}" data-lat="${
              store.latitude
            }" data-lng="${store.longitude}" data-name="${store.name}"></div>
            <div class="store-actions-grid">
              <a href="${
                store.google_maps_url || "#"
              }" target="_blank" rel="noopener noreferrer" class="button button--primary">Directions</a>
              <a href="tel:${
                store.contact_number || ""
              }" class="store-contact-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                <span>${store.contact_number || "No Number"}</span>
              </a>
            </div>
            <div class="store-hours-wrapper">
              <h4 class="operating-hours-title">Opening Hours</h4>
              <div class="operating-hours-grid">${formatOperatingHours(
                store.operating_hours
              )}</div>
            </div>
          </div>
        </li>`;
    });
    listHtml += "</ul>";
    showResults(listHtml);
  }

  function handleError(error) {
    console.error("Error searching:", error);
    showResults(
      `<div class="notice-box info">${infoIconSvg}<span>Sorry, something went wrong while loading store stock. Please try again.</span></div>`
    );
  }

  function showResults(html) {
    elements.resultsContainer.innerHTML = html;
  }

  function formatOperatingHours(hours) {
    if (!hours) return "<div>Hours not available.</div>";

    const daysOrder = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];

    const formatTime = (timeStr) =>
      typeof timeStr === "string" && timeStr.includes(":")
        ? timeStr.slice(0, 5)
        : "";

    const groupedHours = [];
    let currentGroup = null;

    daysOrder.forEach((day) => {
      const dayHours = hours[day];
      let timeRange = "Closed";
      if (dayHours) {
        if (dayHours.all_day) timeRange = "24 Hours";
        else if (dayHours.open && dayHours.close) {
          const openTime = formatTime(dayHours.open);
          const closeTime = formatTime(dayHours.close);
          if (openTime && closeTime) timeRange = `${openTime} - ${closeTime}`;
        }
      }

      if (!currentGroup || currentGroup.timeRange !== timeRange) {
        if (currentGroup) groupedHours.push(currentGroup);
        currentGroup = { days: [day], timeRange: timeRange };
      } else {
        currentGroup.days.push(day);
      }
    });

    if (currentGroup) groupedHours.push(currentGroup);

    const formatDayRange = (days) => {
      const capitalize = (value) =>
        value.charAt(0).toUpperCase() + value.slice(1);
      if (days.length === 1) return capitalize(days[0]);
      return `${capitalize(days[0])} - ${capitalize(days[days.length - 1])}`;
    };

    let html = "";
    groupedHours.forEach((group) => {
      html += `<div>${formatDayRange(group.days)}</div><div>${group.timeRange}</div>`;
    });

    return html || "<div>Hours not available.</div>";
  }

  function loadGoogleMapsApi(callback) {
    if (typeof google !== "undefined" && google.maps) {
      isGoogleMapsApiLoaded = true;
      if (callback) callback();
      return;
    }

    if (window.googleMapsApiLoading) return;

    window.googleMapsApiLoading = true;

    if (!mapsApiUrl) {
      console.error("Maps API URL is not defined in data-maps-api-url attribute.");
      window.googleMapsApiLoading = false;
      return;
    }

    const callbackName = `gmapsCallback_${Date.now()}_${Math.random()
      .toString(36)
      .substr(2, 9)}`;
    const script = document.createElement("script");
    const urlWithCallback =
      mapsApiUrl +
      (mapsApiUrl.includes("?") ? "&" : "?") +
      `callback=${callbackName}`;
    script.src = urlWithCallback;
    script.async = true;
    script.defer = true;

    script.onerror = () => {
      if (script.parentNode) document.head.removeChild(script);
      delete window[callbackName];
      console.error("Failed to load the Google Maps API script.");
      window.googleMapsApiLoading = false;
    };

    window[callbackName] = () => {
      delete window[callbackName];
      if (!window.google || !google.maps) {
        console.error("Google Maps library not properly loaded");
        window.googleMapsApiLoading = false;
      } else {
        isGoogleMapsApiLoaded = true;
        window.googleMapsApiLoading = false;
        if (callback) callback();
      }
    };

    setTimeout(() => {
      if (!window.google || !google.maps) {
        if (script.parentNode) document.head.removeChild(script);
        delete window[callbackName];
        console.error("Google Maps loading timed out");
        window.googleMapsApiLoading = false;
      }
    }, 20000);

    document.head.appendChild(script);
  }

  function initMapForStore(mapElement) {
    if (
      typeof google === "undefined" ||
      !mapElement ||
      mapElement.dataset.mapInitialized === "true"
    ) {
      return;
    }

    const lat = parseFloat(mapElement.dataset.lat);
    const lng = parseFloat(mapElement.dataset.lng);
    const name = mapElement.dataset.name;

    const mapStyles = [
      { elementType: "geometry", stylers: [{ color: "#f3f3f3" }] },
      { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
      { elementType: "labels.text.fill", stylers: [{ color: "#4d4d4d" }] },
      { elementType: "labels.text.stroke", stylers: [{ color: "#ffffff" }] },
      {
        featureType: "poi",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#e5d4d5" }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#d8e4ee" }],
      },
    ];

    const map = new google.maps.Map(mapElement, {
      center: { lat, lng },
      zoom: 15,
      disableDefaultUI: true,
      zoomControl: true,
      styles: mapStyles,
    });

    new google.maps.Marker({
      position: { lat, lng },
      map: map,
      title: name,
    });

    mapElement.dataset.mapInitialized = "true";
  }

  // Button handler is managed exclusively by attachBtnHandler() above.
  // A duplicate assignment here was removed: it held a stale btn reference
  // after Shopify section re-renders and overwrote the handler set by attachBtnHandler().

  function closeModal() {
    if (state.modalOpenTime) {
      const duration = Math.round((Date.now() - state.modalOpenTime) / 1000);
      trackAnalyticsEvent("modal_closed", { duration });
    }

    modal.style.display = "none";
    enableBodyScroll();
    state.modalOpenTime = null;
  }

  elements.closeBtn.onclick = closeModal;
  window.onclick = (event) => {
    if (event.target === modal) {
      closeModal();
    }
  };

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && modal.style.display !== "none") {
      closeModal();
    }
  });

  elements.resultsContainer.addEventListener("click", function (event) {
    const toggleButton = event.target.closest(".store-details-toggle");
    if (toggleButton) {
      const storeId = toggleButton.dataset.target;
      const targetItem = document.getElementById(`store-item-${storeId}`);
      if (!targetItem) return;

      const isActive = targetItem.classList.contains("active");
      document.querySelectorAll(".store-list-item.active").forEach((item) => {
        if (item !== targetItem) {
          item.classList.remove("active");
          const otherButton = item.querySelector(".store-details-toggle");
          if (otherButton) otherButton.textContent = "See More";
        }
      });

      targetItem.classList.toggle("active");
      toggleButton.textContent = isActive ? "See More" : "See Less";
      if (!isActive) {
        initMapForStore(targetItem.querySelector(".store-details-map"));
      }
    }

    const directionsLink = event.target.closest('a[href*="maps.google.com"]');
    if (directionsLink) {
      const itemNode = event.target.closest(".store-list-item");
      trackAnalyticsEvent("directions_clicked", {
        storeName: itemNode ? itemNode.dataset.storeName : null,
      });
    }

    const phoneLink = event.target.closest('a[href^="tel:"]');
    if (phoneLink) {
      const itemNode = event.target.closest(".store-list-item");
      trackAnalyticsEvent("phone_clicked", {
        storeName: itemNode ? itemNode.dataset.storeName : null,
      });
    }
  });

  document.getElementById("use-my-location-btn").onclick = () => {
    showResults(
      `<div class="notice-box info">${preloaderSvg}<span>Finding your location...</span></div>`
    );

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) =>
          findStoresByLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          }),
        () => {
          showResults(
            `<div class="notice-box info">${infoIconSvg}<span>Could not get your location. Please check browser permissions and try again.</span></div>`
          );
        }
      );
    } else {
      showResults(
        `<div class="notice-box info">${infoIconSvg}<span>Geolocation is not supported by your browser.</span></div>`
      );
    }
  };

  document
    .getElementById("address-input")
    .addEventListener("keypress", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        const value = this.value.trim();
        if (value) findStoresByLocation(value);
      }
    });

  function initAutocomplete() {
    if (typeof google === "undefined" || !google.maps || state.autocomplete) {
      return;
    }

    const input = document.getElementById("address-input");
    const options = {
      types: ["geocode"],
      componentRestrictions: { country: "ZA" },
    };
    state.autocomplete = new google.maps.places.Autocomplete(input, options);
    state.autocomplete.addListener("place_changed", () => {
      const place = state.autocomplete.getPlace();
      if (place.geometry && place.geometry.location) {
        findStoresByLocation({
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        });
      }
    });
  }
});